import React, { useEffect } from "react";
import { useGlobalData } from "./config/GlobalContext";
import SplashScreen from "./components/SplashScreen";
import { BrowserRouter, useNavigate } from "react-router";
import { GlobalProvider } from "./config/GlobalContext";
import NotificationProvider from "./config/Notification";
import { ToastContainer } from "react-toastify";
import AppRouter from "./routes/Routes";
import { FavoritesProvider } from "./config/FavoritesContext";
import ErrorBoundary from "./components/ErrorBoundary";
import { setupAxiosInterceptors } from "./utils/errorLogger";
import { useGlobalErrorHandler } from "./hooks/useGlobalErrorHandler";

function AppContent() {
  const navigate = useNavigate();
  const { isSessionLoading } = useGlobalData();

  useGlobalErrorHandler();

  useEffect(() => {
    setupAxiosInterceptors(navigate);
  }, [navigate]);

  if (isSessionLoading) {
    return <SplashScreen />;
  }

  return (
    <>
      <AppRouter />
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
    </>
  );
}

function App() {
  return (
    <ErrorBoundary>
      <GlobalProvider>
        <NotificationProvider>
          <FavoritesProvider>
            <BrowserRouter>
              <AppContent />
            </BrowserRouter>
          </FavoritesProvider>
        </NotificationProvider>
      </GlobalProvider>
    </ErrorBoundary>
  );
}

export default App;
